import { useQuery } from '@tanstack/react-query';
import { PrescriptionApi } from '../../../apis/PrescriptionApi/PrescriptionApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IPrescriptionActivityEvent } from '../Prescription';

export function usePrescriptionActivityHistory(patientId?: string | number) {
    const id = patientId != null ? String(patientId) : undefined;
    return useQuery<IPrescriptionActivityEvent[]>({
        queryKey: [QueryKeys.prescriptionActivity, id],
        queryFn: () => PrescriptionApi.getActivityHistory(id!),
        enabled: !!id,
    });
}
